import React, { Fragment } from 'react'

import {
  Box,
  Divider,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from '@material-ui/core'
import {
  FileText as FileTextIcon,
  Eye as EyeIcon,
  Info as InfoIcon,
} from 'react-feather'
import { isEmpty, last } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { FileUploadInput } from 'components'

import helpers from 'helpers'
import theme from 'theme'
import useStyles from './styles'

const Evidences = ({ evidences }) => {
  const classes = useStyles()

  const handleOpenUrl = (url) => window.open(url, '_blank')

  return (
    <Paper
      component={Box}
      display="flex"
      flexDirection="column"
      gridGap={theme.spacing(2)}
      p={2}
    >
      <Typography variant="h5" color="primary">
        Evidências
      </Typography>

      {evidences?.map((evidence, evidenceIndex) => {
        return (
          <Paper
            key={evidence.id ?? evidenceIndex}
            variant="outlined"
            className={classes.sectionPaper}
          >
            <Box
              display="flex"
              flexDirection="column"
              gridGap={theme.spacing(2)}
            >
              <Typography variant="h6" color="secondary">
                {`${evidenceIndex + 1}. ${evidence?.title}`}
              </Typography>
              {evidence?.description && (
                <Typography variant="body1" color="secondary">
                  {evidence?.description}
                </Typography>
              )}
              {evidence?.justify && (
                <Typography variant="body1" color="secondary">
                  {evidence?.justify}
                </Typography>
              )}
            </Box>

            {!isEmpty(evidence?.modelDocuments) && (
              <Fragment>
                <Box
                  display="flex"
                  alignItems="center"
                  gridGap={theme.spacing(1)}
                  justifyContent="space-between"
                >
                  <Typography variant="h6">Documentos de referência</Typography>
                  <Tooltip
                    title="Documentos de referência são modelos ou guias que podem ser utilizados como base para a elaboração da evidência."
                    arrow
                  >
                    <InfoIcon size={16} cursor="help" />
                  </Tooltip>
                </Box>
                <Paper variant="outlined">
                  <PerfectScrollbar
                    options={{
                      wheelPropagation: true,
                      useBothWheelAxes: false,
                    }}
                    className={classes.attachmentItems}
                  >
                    {evidence?.modelDocuments?.map(
                      (modelDocument, index, arr) => (
                        <Box key={index}>
                          <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            px={2}
                            py={1}
                          >
                            <Box
                              display="flex"
                              alignContent="center"
                              gridGap={theme.spacing(1)}
                            >
                              <FileTextIcon size={20} />
                              <Typography>{modelDocument?.name}</Typography>
                            </Box>
                            <Box>
                              <IconButton
                                variant="contained"
                                onClick={() =>
                                  handleOpenUrl(modelDocument?.url)
                                }
                              >
                                <EyeIcon size={20} />
                              </IconButton>
                            </Box>
                          </Box>
                          {modelDocument !== last(arr) && <Divider />}
                        </Box>
                      ),
                    )}
                  </PerfectScrollbar>
                </Paper>
              </Fragment>
            )}

            <FileUploadInput
              controlName={`evidences.${evidence.id}.files`}
              maxSize={helpers.formatters.file.toBytes(10)}
              hasDownloadFile
              controllerBar
              multiple
              className={classes.whiteInput}
            />
          </Paper>
        )
      })}
    </Paper>
  )
}

export default Evidences
